<template>
  <div>
    <span class="d-inline-flex align-items-center stats--title mb-2 text-secondary fw-bold">{{ title }}
      <b-button :id="'html-tooltip-button-title-' + title" variant="link" class="p-0" v-b-tooltip.hover>
        <img src="@/assets/img/tooltip-icon.svg" alt="Info tooltip" class="tooltip-icon" />
      </b-button>

      <b-tooltip :target="'html-tooltip-button-title-' + title" triggers="hover" custom-class="left-aligned-tooltip"
        html>
        <h5>{{ tooltipText }}</h5>
        {{ tooltipBody }}
      </b-tooltip>
    </span>

    <hr />
    <div class="row align-items-center stats-card-row">
      <div class="col-8">
        <div class="highlight--stats">
          <div class="value--unit">
            <span class="stats--value">
              {{
                title === "Total QR" && typeof value !== "object"
                  ? numberWithCommas(value) + " QR"
                  : typeof value !== "object"
                    ? numberWithCommas(value)
                    : "Loading...."
              }}
            </span>
            <!-- <span class="stats--unit col-md-0 col-sm-0 col-xs-0">{{ unit }}</span> -->
          </div>
          <div class="text-left">
            <template v-if="tooltipData">
              <b-button id="html-tooltip-button" variant="link" class="p-0" v-b-tooltip.hover>
                <h5>
                  <span style="font-weight: normal"> View Detail </span>
                </h5>
              </b-button>
              <b-tooltip target="html-tooltip-button" triggers="hover" custom-class="left-aligned-tooltip" html>
                <br />
                <!-- <b>{{ formatNumberWithCommas(tooltipData.total_product) }}</b> Product <br><br> -->
                <b>{{ formatNumberWithCommas(tooltipData.total_unmaped) }}</b>
                Inactive <br /><br />
                <b>{{ formatNumberWithCommas(tooltipData.total_mapped) }}</b>
                Active <br /><br />
              </b-tooltip>
            </template>
            <template v-else-if="routeToPage">
              <h5 style="color: #348fe2; cursor: pointer">
                <span style="font-weight: normal" @click="$router.push({ name: routeToPage, query: pageQuery })">View
                  Location</span>
              </h5>
            </template>
            <template v-else>
              <h5 style="color: white">-</h5>
            </template>
          </div>
        </div>
      </div>
      <div class="col-4 stats--icon">
        <div class="circle" :style="{
          'background-color': circle_bg_color ? circle_bg_color : '#fff',
          color: circle_text_color ? circle_text_color : '#000',
        }">
          <!-- <i class="far fa-2x" :class="icon"></i> -->
          <span v-html="icon"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobile: this.isMobile(),
    };
  },
  props: [
    "tooltipText",
    "tooltipBody",
    "title",
    "description",
    "value",
    "unit",
    "icon",
    "circle_bg_color",
    "circle_text_color",
    "tooltipData",
    "routeToPage",
    "pageQuery",
  ],
  mounted() { },
  methods: {
    formatNumberWithCommas(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style>
.left-aligned-tooltip .tooltip-inner {
  text-align: left;
  font-size: 12px;
  padding: 5px 10px;
  /* Adjust the padding value as needed */
}
</style>

<style scoped>
.highlight--stats {
  background-color: white;
  border-radius: 8px;
  /* box-shadow: 0px 3px 10px #0000000F; */
  padding: 15px 0px;

  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: center;
}

.value--unit {
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  justify-content: flex-start;
  align-items: flex-end;
}

.stats--title {
  font-size: 13px;
  font-weight: bold;
  color: #383838;
  padding-left: 20px;
  padding-top: 20px;
}

.stats--value {
  font-size: 25px;
  font-weight: bold;
  color: #383838;
  padding-left: 20px;
}

.stats--unit {
  font-size: 14px;
  font-weight: 500;
  color: #d1d1d1;
  padding: 0 0 10px 10px;
}

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-right: 20px;
}

.circle {
  /* Circle size */
  width: 57px;
  height: 57px;

  /* Make it a circle */
  border-radius: 50%;

  /* Circle color */
  /* Red color for demonstration */

  /* Centering the circle inside the container */
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 35px;
}

.stats-card-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin: 0;
}

.stats-card-row>.col-8,
.stats-card-row>.col-4 {
  padding: 0 15px;
  display: flex;
  align-items: center;
}

.tooltip-icon {
  width: 18px;
  height: 18px;
  display: inline-block;
}
</style>